import { computed } from "@vue/composition-api";

import { Item } from "@/tools/msa/models/item";
import { HistoryManager } from "@/utils/history";

export const groupItemsByType = (history: HistoryManager<Item[]>) =>
  computed(() =>
    history.state.value.current.reduce<Record<string, Item[]>>(
      (index, item, itemIndex) => {
        const key = item.type === "code_match" ? item.match.coding.type : "-1";

        if (!(key in index)) {
          index[key] = [];
        }

        index[key].push(item);

        return index;
      },
      {}
    )
  );
